import styled from "@xstyled/styled-components";

import { palette, pxToRem } from "@otta/design-tokens";
import { Company } from "@otta/search/schema";
import { media } from "@otta/design";

const PhotoContainer = styled.div`
  margin-top: ${pxToRem(16)};
  display: grid;
  justify-content: space-between;
  min-height: ${pxToRem(100)};
  min-width: ${pxToRem(425)};

  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: ${pxToRem(16)};

  ${media({ from: "tablet" })`
    margin-top: 0;
    grid-template-columns: ${pxToRem(152)} ${pxToRem(245)};
    grid-gap: ${pxToRem(16)};
    grid-auto-rows: ${pxToRem(156)};
    grid-auto-columns: ${pxToRem(156)};
  `}
`;

const Photo = styled.div<{ source?: string }>`
  background-color: ${palette.grayscale.shade200};
  border-radius: ${pxToRem(8)};
  aspect-ratio: 1;
  height: 100%;
  overflow: hidden;
`;

const Photo1 = styled(Photo)`
  grid-column-start: 1;
  grid-row-start: 1;
  grid-row-end: 2;

  ${media({ from: "tablet" })`
    grid-column-start: 1;
    grid-row-start: 1;
    grid-row-end: 2;
  `}
`;

const Photo2 = styled(Photo)`
  grid-column-start: 2;
  grid-row-start: 1;
  grid-row-end: 2;

  ${media({ from: "tablet" })`
    grid-column-start: 1;
    grid-row-start: 2;
    grid-row-end: 3;
  `}
`;

const Photo3 = styled(Photo)`
  grid-column-start: 3;
  grid-row-start: 1;
  grid-row-end: 2;
  width: 100%;

  ${media({ from: "tablet" })`
    aspect-ratio: 0.5;
    grid-column-start: 2;
    grid-row-start: 1;
    grid-row-end: 3;
  `};
`;

const InnerImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CompanyImagesSection = ({
  company,
}: {
  company: Company.Company;
}) => {
  if (company.profileHeaderImages.length < 3) {
    return null;
  }

  return (
    <PhotoContainer data-testid="company-images">
      <Photo1
        source={
          company.profileHeaderImages[0].desktopPlacement?.source ?? undefined
        }
        data-testid="image-1"
      >
        <InnerImg
          src={
            company.profileHeaderImages[0].desktopPlacement?.source ?? undefined
          }
          alt={company.profileHeaderImages[0].companyBrandAsset.alt || ""}
        />
      </Photo1>
      <Photo2
        source={
          company.profileHeaderImages[1].desktopPlacement?.source ?? undefined
        }
        data-testid="image-2"
      >
        <InnerImg
          src={
            company.profileHeaderImages[1].desktopPlacement?.source ?? undefined
          }
          alt={company.profileHeaderImages[1].companyBrandAsset.alt || ""}
        />
      </Photo2>
      <Photo3
        source={
          company.profileHeaderImages[2].desktopPlacement?.source ?? undefined
        }
        data-testid="image-3"
      >
        <InnerImg
          src={
            company.profileHeaderImages[2].desktopPlacement?.source ?? undefined
          }
          alt={company.profileHeaderImages[2].companyBrandAsset.alt || ""}
        />
      </Photo3>
    </PhotoContainer>
  );
};
